import { jsx } from 'react/jsx-runtime';
import { IconBuzzNoteText } from '@fabric-app/icons/old';

const ResourcePreviewListItemHighlight = () => {
  return /* @__PURE__ */ jsx(IconBuzzNoteText, {
    style: {
      width: "1rem",
      height: "1rem"
    }
  });
};

export { ResourcePreviewListItemHighlight };
//# sourceMappingURL=ResourcePreviewListItemHighlight.js.map
